import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../Utils/Endpoints';
import { colorNormalize } from '../Objetos/ColoresModel';
import ThemeDesigner from '../Components/ThemeDesigner';
import AlertDialog from '../../Lms/Components/Shared/AlertDialog';

export default function VisualDesignerPage() {
    const [themes, setThemes] = useState([]);
    const [selectedTheme, setSelectedTheme] = useState(null);
    const [loading, setLoading] = useState(true);
    const [alertConfig, setAlertConfig] = useState({ open: false, message: '', title: 'Información', variant: 'info' });

    const triggerAlert = (message, variant = 'info', title = 'Información') => {
        setAlertConfig({ open: true, message, variant, title });
    };

    const loadThemes = async () => {
        setLoading(true);
        try {
            const res = await axios.get(ENDPOINTS.colores);
            const data = (res.data || []).map(x => colorNormalize(x));
            setThemes(data);

            // Si hay un tema activo lo seleccionamos, si no el primero
            const active = data.find(t => t.activo) || data[0];
            setSelectedTheme(active);
        } catch (error) {
            console.error('Error al cargar temas:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadThemes();
    }, []);

    const handleSave = async (updatedTheme) => {
        try {
            await axios.put(ENDPOINTS.colores, {
                idColor: updatedTheme.idColor,
                nombre: updatedTheme.nombre,
                descripcion: updatedTheme.descripcion,
                valor: updatedTheme.valor,
                activo: updatedTheme.activo
            });
            triggerAlert('Tema guardado correctamente', 'success', 'Éxito');
            loadThemes();
        } catch (error) {
            console.error('Error al guardar tema:', error);
            triggerAlert('Error al guardar el tema', 'error', 'Error');
        }
    };

    if (loading) return <div className="catalog-loading">Cargando Diseñador...</div>;

    if (!selectedTheme) {
        return (
            <div className="panel-sigma-main" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="roles-shell" style={{ textAlign: 'center', padding: '40px' }}>
                    <h3>No hay temas configurados</h3>
                    <p>Por favor crea un tema en el catálogo de colores primero.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="panel-sigma-main" style={{ padding: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>
            {/* Cabecera independiente para el diseñador si se desea permitir cambiar de tema */}
            {themes.length > 1 && (
                <div style={{ padding: '10px 20px', background: '#fff', borderBottom: '1px solid #e2e8f0', display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '0.9rem' }}>Editar tema:</span>
                    <select
                        className="roles-search"
                        style={{ width: 'auto', flex: 'none', height: '32px', padding: '0 10px' }}
                        value={selectedTheme.idColor}
                        onChange={(e) => setSelectedTheme(themes.find(t => t.idColor === parseInt(e.target.value)))}
                    >
                        {themes.map(t => (
                            <option key={t.idColor} value={t.idColor}>{t.nombre} {t.activo ? '(Activo)' : ''}</option>
                        ))}
                    </select>
                </div>
            )}

            <div style={{ flex: 1 }}>
                <ThemeDesigner
                    themeData={selectedTheme}
                    onSave={handleSave}
                    onCancel={() => window.history.back()}
                />
            </div>

            <AlertDialog
                open={alertConfig.open}
                title={alertConfig.title}
                message={alertConfig.message}
                variant={alertConfig.variant}
                onClose={() => setAlertConfig({ ...alertConfig, open: false })}
            />
        </div>
    );
}
